import {
    EnvironmentActions,
    EnvironmentActionTypes,
    EnvironmentState,
} from "#store/environment/environmentTypes";

/**
 * make sure that the docker entrypoint (`/docker/docker-entrypoint.sh`) reads all relevant environment variables,
 * and in general, is in sync with this state.
 */
const initialState: EnvironmentState = {
    SERVICE_URL: "",
    state: "new",
    refetchTimeout: 2000,
};

/** reducer */
export function environmentReducer(
    state = initialState,
    action: EnvironmentActions
): EnvironmentState {
    switch (action.type) {
        case EnvironmentActionTypes.UPDATE_ENVIRONMENT: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case EnvironmentActionTypes.LOAD_SUCCESS: {
            return {
                ...state,
                state: "running",
            };
        }
        case EnvironmentActionTypes.LOAD_START:
            return {
                ...state,
                state: "starting",
            };
        case EnvironmentActionTypes.LOAD_ERROR:
            return {
                ...state,
                state: "failed",
            };
        default:
            return state;
    }
}
